import { render, staticRenderFns } from "./AssignmentsPanel.vue?vue&type=template&id=08822315&"
import script from "./AssignmentsPanel.vue?vue&type=script&lang=js&"
export * from "./AssignmentsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports